import * as taskName from './task-name'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'

export default createUIDefinition({
    taskName: taskName.CHECK_IMAGES_POST,
    overwriteWidget: true,

    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.IMPRINT_SCAN_STATUS_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },

    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []

        const lowerJawVisuallyOK = context.lowerJawVisuallyOK
        const upperJawVisuallyOK = context.upperJawVisuallyOK

        // make sure at least one is true
        if (eventName === 'at_least_one_imprint_visually_ok' && (!lowerJawVisuallyOK && !upperJawVisuallyOK)) {
            messageList.push(createValidationMessage('For this action at least one imprint has to be visually ok.', 'validateCheckImprintVisually.at_least_one_imprint_visually_ok'))
        }

        // both have to be false
        if (eventName === 'both_imprints_visually_not_ok' && (lowerJawVisuallyOK || upperJawVisuallyOK)) {
            messageList.push(createValidationMessage('For this action both imprints must not be visually ok.', 'validateCheckImprintVisually.both_imprints_visually_not_ok'))
        }

        const cannotBeTreatedReason = context.cannotBeTreatedReason
        if (!cannotBeTreatedReason && eventName === 'cannot_be_treated') {
            messageList.push(createValidationMessage("Please add the reason for 'cannot be treated' before proceeding.", 'checkDeliveryTracking.checkDeliveryTracking'))
        }

        return messageList
    },
})




// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/check-images-post.js